import { EvaChart } from "constants/charts.enums";

// This function determines the number of icons to display based on the chart type and overflow index.
// It takes into account specific chart types and their behavior regarding icon display.
// i.e the pie chart doesnt have a product selector or raw data table view so we can render more icons
export const getNumberOfIconsToDisplay = (
  chartType: EvaChart,
  overflowIndex: number
): number => {
  let result: number;

  if (overflowIndex <= 0) {
    return 0;
  }

  switch (chartType) {
    case EvaChart.TrendDate:
    case EvaChart.CrossPlot:
    case EvaChart.BoxPlot:
    case EvaChart.Probit:
    case EvaChart.StackedBar:
    case EvaChart.StackedBarHorizontal:
    case EvaChart.InjectorTotal:
      result = overflowIndex;
      break;
    case EvaChart.Mosaic:
    case EvaChart.MosaicMidstream:
    case EvaChart.Pie:
      result = overflowIndex + 1;
      break;
    default:
      result = overflowIndex - 1;
      break;
  }
  return result;
};
